import '@appbaseio/reactivecore';
import './_rollupPluginBabelHelpers-0f24d612.js';
import 'vue-types';
import '@appbaseio/reactivecore/lib/utils/constants';
import '@appbaseio/reactivecore/lib/utils/helper';
import 'emotion';
import '@appbaseio/vue-emotion';
import 'polished';
import './Button-91561391.js';
import './vueTypes-687b2304.js';
export { default as ReactiveList } from './ReactiveList.js';
import '@appbaseio/reactivecore/lib/utils/transform';
import 'redux';
import './index-cb1950b6.js';
import './ComponentWrapper-4f85a67e.js';
import '@vue/babel-helper-vue-jsx-merge-props';
import './Title-3522ff56.js';
import './ListItem-8e8fb535.js';
import './Card-6446f1b7.js';
import './Flex-8770345d.js';
import '@appbaseio/reactivecore/lib/actions/analytics';
import 'appbase-js';
import 'url-search-params-polyfill';
export { default as ReactiveBase } from './ReactiveBase.js';
import 'hotkeys-js';
export { default as DataSearch } from './DataSearch.js';
import './CancelSvg-c2c03a35.js';
import './Input-08bb1bcf.js';
import 'compute-scroll-into-view';
import './Container-18b03fde.js';
import 'vue-highlight-words';
import '@appbaseio/reactivecore/lib/utils/suggestions';
import './FormControlList-704f8dee.js';
import './utils-64a2e5f0.js';
export { default as SingleList } from './SingleList.js';
export { default as MultiList } from './MultiList.js';
import './DropDown-c8da0a2c.js';
export { default as SingleDropdownList } from './SingleDropdownList.js';
export { default as MultiDropdownList } from './MultiDropdownList.js';
export { default as ToggleButton } from './ToggleButton.js';
export { default as ReactiveComponent } from './ReactiveComponent.js';
export { default as SelectedFilters } from './SelectedFilters.js';
export { default as SingleRange } from './SingleRange.js';
export { default as MultiRange } from './MultiRange.js';
export { default as ResultCard } from './ResultCard.js';
export { default as ResultList } from './ResultList.js';
import 'vue-no-ssr';
import './ssr-a41dfea9.js';
export { default as RangeSlider } from './RangeSlider.js';
export { default as DynamicRangeSlider } from './DynamicRangeSlider.js';
export { default as StateProvider } from './StateProvider.js';
import '@appbaseio/reactivecore/lib/reducers/valueReducer';
import '@appbaseio/reactivecore/lib/reducers/queryReducer';
import '@appbaseio/reactivecore/lib/reducers/queryOptionsReducer';
import '@appbaseio/reactivecore/lib/reducers/compositeAggsReducer';
import '@appbaseio/reactivecore/lib/constants';
import '@appbaseio/reactivecore/lib/reducers/dependencyTreeReducer';
import '@appbaseio/reactivecore/lib/utils/graphQL';
import '@appbaseio/reactivecore/lib/actions/utils';
export { default as initReactivesearch } from './initReactivesearch.js';
import version from './version.js';
export { default as version } from './version.js';
export { default as RangeInput } from './RangeInput.js';
import install from './install.js';
export { default as install } from './install.js';

// Add polyfills to support in IE

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}
var index = {
  version: version,
  install: install
};

export default index;
